var $c5ac7ec630c67dba$exports = {};
$c5ac7ec630c67dba$exports = {
  "pending": "\u0432 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438"
};
export { $c5ac7ec630c67dba$exports as default };